import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Resolver } from "~/components/Resolver.jsx";
import { fetchPersonalizedConfigOptions } from "~/store/actions/actions.personalizedConfigOptions";
import { CapacityLoader } from "./CapacityLoader";
import { UtilizationTable } from "./UtilizationTable";

const UtilizationTableWrapper = () => {
  const dispatch = useDispatch();
  const getConfigOptions = useCallback(async () => {
    await dispatch(fetchPersonalizedConfigOptions(["utilization_levels", "utilization_show_only_billable_hours"]));
  }, [dispatch]);

  return (
    <Resolver
      loadingComponent={<CapacityLoader />}
      callback={getConfigOptions}
    >
      <UtilizationTable />
    </Resolver>
  );
};

export default UtilizationTableWrapper;
